import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class SidebarService {
  private subject = new Subject<any>();


  triggerSidebarUpdate(cart_type: any): void {
    this.subject.next({update: true, cart_type});
  }

  updateSidebar(): Observable<any> {
    return this.subject.asObservable();
  }
}
